import { render, staticRenderFns } from "./ViewComponent.vue?vue&type=template&id=104a1919&scoped=true"
import script from "./ViewComponent.vue?vue&type=script&lang=js"
export * from "./ViewComponent.vue?vue&type=script&lang=js"
import style0 from "./ViewComponent.vue?vue&type=style&index=0&id=104a1919&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104a1919",
  null
  
)

export default component.exports